var map = {
	"./academy.svg": 61243,
	"./alcarta.svg": 1968,
	"./alert.svg": 80992,
	"./app-picker.svg": 81836,
	"./arrange-2.svg": 57962,
	"./arrange.svg": 85002,
	"./arrow-clockwise.svg": 21575,
	"./arrow-counterclockwise.svg": 4274,
	"./arrow-left-condensed.svg": 69373,
	"./arrow-left.svg": 52867,
	"./arrow-right.svg": 97591,
	"./book.svg": 37465,
	"./bookmark.svg": 66654,
	"./careup.svg": 52986,
	"./checkmark-circle.svg": 90922,
	"./checkmark.svg": 32304,
	"./chevron-down.svg": 2625,
	"./chevron-left.svg": 78309,
	"./chevron-right.svg": 5714,
	"./chevron-up.svg": 69970,
	"./clock.svg": 10112,
	"./close.svg": 32559,
	"./compose.svg": 9273,
	"./copyright.svg": 39546,
	"./cursor.svg": 27938,
	"./doc.svg": 70364,
	"./down.svg": 245,
	"./download.svg": 64390,
	"./email.svg": 2853,
	"./exe.svg": 66844,
	"./expand.svg": 38329,
	"./external.svg": 33852,
	"./facebook.svg": 84734,
	"./file.svg": 31478,
	"./flag.svg": 25327,
	"./folder.svg": 373,
	"./group.svg": 8661,
	"./heart-empty.svg": 83432,
	"./heart-filled.svg": 17533,
	"./info.svg": 8721,
	"./like.svg": 89231,
	"./link.svg": 59977,
	"./linkedin.svg": 83417,
	"./listen.svg": 79880,
	"./lock.svg": 42560,
	"./magnifier-minus.svg": 25275,
	"./magnifier-plus.svg": 78165,
	"./magnifier.svg": 66294,
	"./menu.svg": 25037,
	"./microphone.svg": 66492,
	"./minus.svg": 22438,
	"./music.svg": 88215,
	"./next.svg": 1454,
	"./notification.svg": 45267,
	"./open.svg": 64947,
	"./pause.svg": 95610,
	"./pdf.svg": 7161,
	"./play.svg": 432,
	"./plus.svg": 60400,
	"./ppt.svg": 84689,
	"./previous.svg": 87026,
	"./replay.svg": 31688,
	"./results.svg": 39748,
	"./share.svg": 62951,
	"./speaker.svg": 29630,
	"./speechcloud.svg": 65383,
	"./star.svg": 45205,
	"./teacher-options.svg": 70263,
	"./timer.svg": 18670,
	"./trashcan.svg": 28580,
	"./twitter.svg": 16204,
	"./unlocked.svg": 36916,
	"./up.svg": 34839,
	"./upload.svg": 89605,
	"./user.svg": 67221,
	"./video.svg": 51607,
	"./view.svg": 95488,
	"./warning.svg": 61085,
	"./whatsapp.svg": 3680,
	"./xls.svg": 58440,
	"./zip.svg": 30902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74490;